export default __webpack_public_path__ + "0dafbf944e00968731513e1d3eb34d47.svg";